import { FC } from 'react';
import { ICollections } from '@/interfaces/collections.interface';
import CollectionItem from '../collection-item/CollectionItem';
import styles from './HomeCollectionList.module.scss';
import Link from 'next/link';

interface IHomeCollectionList {
  data: ICollections;
}

const HomeCollectionList: FC<IHomeCollectionList> = ({ data }) => {
  const cloneData = Object.assign({}, data);

  return (
    <>
      <div className="contentHeader">
        <div className="contentHeader__item">
          <b>Cписки</b>
        </div>
      </div>
      <div className="content">
        <div className={styles.homeCollectionList}>
          {data.data.slice(0, 2).map((item) => {
            return <CollectionItem key={item.id} item={item} />;
          })}

          {cloneData.data.slice(2, 6).map((item) => {
            return <CollectionItem key={item.id} item={item} extraClassName="collectionItem_small" />;
          })}
          <Link prefetch={false} className="allBooksLink" href="/collections">
            Все списки
          </Link>
        </div>
      </div>
    </>
  );
};
export default HomeCollectionList;
